module.exports = __webpack_public_path__ + "img/search.c7cc107b.svg";